
import {userApi} from './user'

//todo: invalidate tag for both the users here 

export const userNotificationDeleteApi = userApi.injectEndpoints({
  endpoints: (builder) => ({   
    
    userNotificationDelete: builder.mutation({
     
      query: (notificationId) => ({
        url: `/notifications/${notificationId}/delete`,
        method: 'POST'
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useUserNotificationDeleteMutation } = userNotificationDeleteApi

